/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TicketEditService } from './ticket-edit.service';
import { TicketEditServiceTemplater } from './ticket-edit-templater.service';

import { EditWrapperComponent } from './components/edit-wrapper/edit-wrapper.component';
import { EditType } from './edit-type.directive';

import { UtilityComponentsModule } from 'src/app/common/utility-components/utility-components.module';
import { ConstraintAcceptanceService } from './constraint-acceptance.service';
import { TicketWorkDaysMessageComponent } from './components/ticket-work-days-message/ticket-work-days-message.component';
import { TicketEditContextMenuComponent } from './components/ticket-edit-context-menu/ticket-edit-context-menu.component';
import { TicketQuickStatusPromptComponent } from './components/ticket-quick-status-prompt/ticket-quick-status-prompt.component';
import { VariancePromptComponent } from './components/variance-prompt/variance-prompt.component';
import { TaskEditComponent } from './components/task-edit/task-edit.component';
import { ConstraintEditComponent } from './components/constraint-edit/constraint-edit.component';
import { ConstraintRoleOverlayComponent } from './components/constraint-role-overlay/constraint-role-overlay.component';
import { MilestoneEditComponent } from './components/milestone-edit/milestone-edit.component';
import { MultiEditThumbnail } from './components/multi-edit-thumbnail/multi-edit-thumbnail.component';
import { MultiEditMastheadComponent } from './components/multi-edit-masthead/multi-edit-masthead.component';
import { TicketActionMenuComponent } from './components/ticket-action-menu/ticket-action-menu.component';
import { TicketRoleComponent } from './components/ticket-role/ticket-role.component';
import { TicketLocationComponent } from './components/ticket-location/ticket-location.component';
import { TicketMessageComponent } from './components/ticket-message/ticket-message.component';
import { TicketDescriptionComponent } from './components/ticket-description/ticket-description.component';
import { TicketFooterComponent } from './components/ticket-footer/ticket-footer.component';
import { TicketCalendarComponent } from './components/ticket-calendar/ticket-calendar.component';
import { TicketCrewComponent } from './components/ticket-crew/ticket-crew.component';
import { TicketPinHistoryComponent } from './components/ticket-pin-history/ticket-pin-history.component';
import { TicketProcoreLinkComponent } from './components/ticket-procore-link/ticket-procore-link.component';
import { TicketProcoreStatusComponent } from './components/ticket-procore-status/ticket-procore-status.component';
import { TicketVarianceComponent } from './components/ticket-variance/ticket-variance.component';
import { TicketDurationComponent } from './components/ticket-duration/ticket-duration.component';
import { MultiWrapperComponent } from './components/multi-wrapper/multi-wrapper.component';
import { TicketProjectMemberComponent } from './components/ticket-project-member/ticket-project-member.component';
import { MultiEditConstraintComponent } from './components/multi-edit-constraint/multi-edit-constraint.component';
import { MultiEditMilestoneComponent } from './components/multi-edit-milestone/multi-edit-milestone.component';
import { MultiEditTaskComponent } from './components/multi-edit-task/multi-edit-task.component';
import { CustomFieldSharedModule } from '../custom-field/custom-field-shared.module';
import { SharedUIMaterialModule } from 'src/app/shared/ui/material/shared-ui-material.module';
import { MaterialModule } from 'src/app/common/material/material-module';
import { ExternalScheduleIdComponent } from './components/ticket-ext-sched-id/ticket-ext-sched-id.component';
import { TicketDependencyDialogComponent } from './components/ticket-dependency-dialog/ticket-dependency-dialog.component';
import { PresentationModule } from 'src/app/common/presentation-components/presentation.module';
import { FeatureFlagManager } from 'src/app/services/FeatureFlagManager';
import { DialogReusableModule } from 'src/app/common/dialog-reusable/dialog-reusable.module';
import { WbsCodeComponent } from './components/ticket-wbs-code/ticket-wbs-code.component';
import { MilestoneTypeComponent } from './components/ticket-milestone-type/ticket-milestone-type.component';
import { TicketThumbnailComponent } from '../../components/ticket/ticket-thumbnail/ticket-thumbnail.component';
import { TicketPromiseIconComponent } from '../../components/ticket/ticket-promise-icon/ticket-promise-icon.component';
import { AutomationIdDirective } from '../../shared/directives/automation-id/automation-id.directive';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		UtilityComponentsModule,
		CustomFieldSharedModule,
		SharedUIMaterialModule,
		MaterialModule,
		PresentationModule,
		DialogReusableModule,
		TicketThumbnailComponent,
		TicketPromiseIconComponent,
		AutomationIdDirective,
	],
	providers: [TicketEditService, TicketEditServiceTemplater, ConstraintAcceptanceService, FeatureFlagManager],
	declarations: [
		EditWrapperComponent,
		EditType,
		TaskEditComponent,
		ConstraintEditComponent,
		ConstraintRoleOverlayComponent,
		MilestoneEditComponent,
		MultiEditThumbnail,
		MultiEditMastheadComponent,
		TicketActionMenuComponent,
		TicketRoleComponent,
		TicketLocationComponent,
		ExternalScheduleIdComponent,
		WbsCodeComponent,
		TicketMessageComponent,
		TicketDescriptionComponent,
		TicketFooterComponent,
		TicketCalendarComponent,
		TicketCrewComponent,
		TicketPinHistoryComponent,
		TicketProcoreLinkComponent,
		TicketProcoreStatusComponent,
		TicketWorkDaysMessageComponent,
		TicketVarianceComponent,
		TicketDurationComponent,
		MultiWrapperComponent,
		TicketProjectMemberComponent,
		MultiEditConstraintComponent,
		MultiEditMilestoneComponent,
		MultiEditTaskComponent,
		VariancePromptComponent,
		TicketQuickStatusPromptComponent,
		TicketEditContextMenuComponent,
		TicketDependencyDialogComponent,
		MilestoneTypeComponent,
	],
	exports: [
		VariancePromptComponent,
		TicketQuickStatusPromptComponent,
		TicketEditContextMenuComponent,
		TicketWorkDaysMessageComponent,
		TicketDependencyDialogComponent,
	],
})
export class TicketEditModule {}
